import { render, staticRenderFns } from "./BasicLayoutH.vue?vue&type=template&id=67213eb5&scoped=true"
import script from "./BasicLayoutH.vue?vue&type=script&lang=js"
export * from "./BasicLayoutH.vue?vue&type=script&lang=js"
import style0 from "./BasicLayoutH.vue?vue&type=style&index=0&id=67213eb5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67213eb5",
  null
  
)

export default component.exports